/**
 * 自定义 RespError
 */
class RespError extends Error {
    constructor(code, message, data = null) {
        super(`失败：Code:${code},message:${message}`);
        this.name = 'RespError';
        this.code = code;
        this.message = message;
        this.data = data;
    }
}
export { RespError };
